// src/hooks/useHourMetrics.js
import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useHourMetrics(routeId, options = {}) {
  const { adapter } = useRegion();
  const { enabled = true, refetchInterval = null } = options;
  const active = enabled && Boolean(routeId);

  return usePolledResource(
    () => adapter.fetchHourMetrics(routeId),
    [routeId, active, refetchInterval, adapter],
    { enabled: active, refetchInterval, initialData: [] }
  );
}